"use strict";
const { v4: uuidv4 } = require('uuid');

exports.uuidv4 = uuidv4;

exports.getCopy = function (obj) {
  var newObj;
  if (typeof obj !== 'undefined') {
    /*var objJStr = JSON.stringify(obj);
    newObj = JSON.parse(objJStr); */

    newObj = Object.assign({}, obj);

  }
  return newObj;
}

exports.getDeepCopy = function (obj) {
  var newObj = undefined;
  if ((obj) && (typeof obj !== 'undefined')) {
    try {
      var objJStr = JSON.stringify(obj);
      newObj = JSON.parse(objJStr);
      //newObj = Object.assign({},obj);
      return newObj;
    } catch (error) {
      return;
    }
  }
  return newObj;
};

exports.hasKeyName = function (obj, keyName) {
  return Object.prototype.hasOwnProperty.call(obj, keyName);
}


exports.getKeyValue = function (obj, key, default_value) {
  if (obj && (typeof obj === 'object') && (typeof key === 'string' || typeof key === "number") && (Object.prototype.hasOwnProperty.call(obj, key)) && (obj[key] !== 'undefined')) {
    return obj[key];
  } else {
    return default_value;
  }
};



exports.isEmptyObject = function (obj) {
  if (obj && (typeof obj !== 'undefined')) {
    return (Object.keys(obj).length === 0);
  } else {
    return true;
  }
};



exports.isEmptyArray = function (array) {
  if (array && (typeof array !== 'undefined')) {
    return ((!Array.isArray(array)) || (array.length === 0));
  } else {
    return true;
  }
};

exports.isArray = function (array) {
  if (array && (typeof array !== 'undefined')) {
    return Array.isArray(array);
  } else {
    return false;
  }
};

exports.isObject = function (obj) {
  if (typeof obj == 'object') {
    return true;
  } else {
    return false;
  }
};

exports.isSpace = function (aChar) {
  let myCharCode = aChar.charCodeAt(0);

  if (((myCharCode > 8) && (myCharCode < 14)) ||
    (myCharCode == 32)) {
    return true;
  }

  return false;
}
exports.validateName = function (nameStr) {
  if ((typeof nameStr === 'string') && (nameStr.length >= 0)) {
    var reg = /^((?![\x00-\x1f\x7f-\xff\[\]\{\}\*\?]).)*$/;
    //var reg2 = /^(\w+\s?)*\s*$/;
    //return reg.test(nameStr) && (reg2.test(nameStr));
    // console.log("validating Name  : ",reg.test(nameStr));
    return reg.test(nameStr);
  } else {
    return false;
  }

}


exports.validateEmail = function (emailStr) {

  //console.log("emailStr: ", emailStr);

  if ((typeof emailStr === 'string') && (emailStr.length > 0)) {
    //var reg = /^((?![\x00-\x1f\x7f-\xff\[\]\{\}\*\?]).)*$/;
    // var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9_\-]+\.)+[a-zA-Z]{2,}))$/
    // console.log("validating Email  : ",reg.test(emailStr));
    return reg.test(emailStr);
  } else {
    return false;
  }


};

exports.validatePhoneNumber = function (phoneStr) {
  /*  
    This function will allow phone numbers entered in the formats like this
      (123) 456-7890
      (123)456-7890
      123-456-7890
      1234567890
  */
  if ((typeof phoneStr === 'string') && (phoneStr.length > 0)) {

    // var re = /^\+((?:9[679]|8[035789]|6[789]|5[90]|42|3[578]|2[1-689])|9[0-58]|8[1246]|6[0-6]|5[1-8]|4[013-9]|3[0-469]|2[70]|7|1)(?:\W*\d){0,13}\d$/im;
    var reg = /^\+((?:9[679]|8[035789]|6[789]|5[90]|42|3[578]|2[1-689])|9[0-58]|8[1246]|6[0-6]|5[1-8]|4[013-9]|3[0-469]|2[70]|7|1)(?:\W*\d){6,13}\d$/igm
    return reg.test(phoneStr);
  } else return false;
};


exports.validateNewPassword = function (p) {
  if ((typeof p === 'string') && (p.length > 0)) {

    var reg = /^([@#](?=[^aeiou]{7,13}$)(?=[[:alnum:]]{7,13}$)(?=.*[A-Z]{1,}.*$).+)$/gm;
    //console.log("validating Password : ",re.test(p));
    return reg.test(p);
  } else {
    return false;
  }

};

exports.toPascalCase = function (strText) {
  var s = strText;
  s = s.replace(/(\w)(\w*)/g,
    function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); });
  return (s);
};

async function digestMessage(message) {
  const msgUint8 = new TextEncoder().encode(message);                           // encode as (utf-8) Uint8Array
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);           // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer));                     // convert buffer to byte array
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
  return hashHex;

};


function repalceAllSpaces(str, char = '') {

  if ((typeof str === 'string') && (str.length > 0) && (typeof char === 'string') && (char.length > 0 || char === '')) {
    let srcChar = char;
    if (srcChar.length > 1) {
      srcChar = char[0];
    }

    str = str.trim();
    str = str.replace(/\s+/g, char);

    //console.log("repalceAllSpaces", str, char);

  }

  return str;
}

function removeAllSpaces(str) {
  //console.log("removeAllSpaces", str);
  return repalceAllSpaces(str, '');
}


function trimSpacesToOne(str) {
  if ((typeof str === 'string') && (str.length > 0)) {

    str = str.trim();
    str = str.replace(/\s+/g, ' ')
      .replace(/^\s+|\s+$/, '');

  }

  return str;
}

function trimSpacesButLastOne(str) {
  if ((typeof str === 'string') && (str.length > 0)) {
    let islastCharSpace = (str[str.length - 1] === ' ') ? true : false;
    str = trimSpacesToOne(str);
    if (islastCharSpace) {
      str = str + ' ';
    }
  }

  return str;
}

function isEmptyString (strText) {
  if ((typeof strText === 'string') && (strText.length > 0)) {
    return true;
  } else {
    return false;
  }
};

function validateLength (strText, iLen){
  if(isEmptyString(strText))
  {
    if(strText.length > iLen){
      return false;
    }else{
      return true;
    }
  }
  return false;
};


exports.repalceAllSpaces  = repalceAllSpaces;
exports.removeAllSpaces   = removeAllSpaces;
exports.trimSpacesToOne   = trimSpacesToOne;
exports.digestMessage     = digestMessage;
exports.isEmptyString     = isEmptyString;
exports.validateLength    = validateLength;

exports.trimSpacesButLastOne = trimSpacesButLastOne;

exports.objectHasOwnProperty = function (obj, key_name) {

  if (typeof obj === 'object' && typeof (typeof key === 'string' || typeof key === "number")) {
    return Object.prototype.hasOwnProperty.call(obj, key_name);
  } else {
    return false;
  }

}

/******************************************************************** */





function convertTimezone(num) {
  var sign = (num > 0) ? "-" : (num < 0) ? "+" : "";
  if (num < 0) { num = -1 * num; }
  var hours = Math.floor(num / 60);
  var minutes = num % 60;
  return sign + hours + ":" + minutes;
}

exports.convertTimezone = convertTimezone;


exports.getTimezoneOffsetStr = function () {
  var d = new Date();
  var n = d.getTimezoneOffset();

  return convertTimezone(n);
}

exports.range = function (start, stop, step) {
  if (typeof start === "number" && (typeof stop === "number" || typeof stop === "undefined") && (typeof step === "number" || typeof step === "undefined")) {
    if (typeof stop === "undefined") {
      // one param defined
      stop = start;
      start = 0;
      return [...Array(stop).keys()]
    } else {
      var result = [];
      if (typeof step === "undefined") {
        step = 1;
      }

      if ((step === 0) || (step > 0 && start >= stop) || (step < 0 && start <= stop)) {
        return result;
      }


      for (var i = start; step > 0 ? (i < stop) : (i > stop); i += step) {
        result.push(i);
      }
      return result;
    }

  }

  return [];

}

exports.validateIPV4address = function (ipAddress) {

  var reg = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

  if (!(reg.test(ipAddress))) {
    return false;
  }

  // "0.0.0.0" or any variation of "0s" are considered not valid.
  let sumOfDecimals = ipAddress.split(".").reduce(function (accumulator, currentValue) { return accumulator + parseInt(currentValue) }, 0);
  return (sumOfDecimals > 0);

}


exports.validatePortNumber = function (portNumber) {   
  //from 0 till 65535 
  var regex = /^((6553[0-5])|(655[0-2][0-9])|(65[0-4][0-9]{2})|(6[0-4][0-9]{3})|([1-5][0-9]{4})|([0-5]{0,5})|([0-9]{1,4}))$/;
  return regex.test(portNumber);

}

